import { request, requestSiteMutation } from "./client";
import { notifySiteChanged } from "../siteEvents";
import type {
  EditorSelectionContext,
  IterateSelection,
  Job,
  Site,
} from "./types";

const terminalJobs = new Map<string, string>();
const terminalStatuses = new Set(["ready", "ready_unverified", "failed", "runner_start_failed", "timeout", "cancelled"]);

export const buildsApi = {
  startBuild: (siteId: string, kind: "iterate" | "preview" | "initial", message?: string, editorContext?: EditorSelectionContext, selection?: IterateSelection, recoveryParentJobId?: string) =>
    requestSiteMutation<{ jobId: string }>(`/api/sites/${siteId}/builds`, {
      method: "POST",
      body: JSON.stringify({ kind, message, editorContext, selection, recoveryParentJobId }),
    }),
  getJob: async (jobId: string) => {
    const result = await request<{ job: Job }>(`/api/jobs/${jobId}`);
    const status = result.job.execution?.status ?? result.job.status;
    if (terminalStatuses.has(status) && terminalJobs.get(jobId) !== status) {
      terminalJobs.set(jobId, status);
      if (terminalJobs.size > 256) terminalJobs.delete(terminalJobs.keys().next().value!);
      // /jobs settles the site's pointers before returning terminal status.
      notifySiteChanged();
    }
    return result;
  },
  cancelBuild: (siteId: string, jobId: string) =>
    requestSiteMutation<{ ok: true; status: string }>(`/api/sites/${siteId}/builds/${jobId}/cancel`, {
      method: "POST",
    }),
  listBuilds: (siteId: string) =>
    request<{
      jobs: Job[];
      previewBuildId: string | null;
      liveBuildId: string | null;
      pendingBuildId: string | null;
    }>(
      `/api/sites/${siteId}/builds`,
    ),
  publish: (siteId: string, buildId: string, version?: number) =>
    requestSiteMutation<Site>(`/api/sites/${siteId}/publish`, {
      method: "POST",
      body: JSON.stringify({ buildId, version }),
    }),
};
